import { object, string, array } from 'yup';
export const ZoneTableSchema = object({
  id_organisation: string().required('L\'identifiant de l\'organisation est obligatoire !'),
  tables: array(string()),
  libelle: string().required('Le libellé est obligatoire !'),
});